import ReactDOM from 'react-dom';

import { SupportCenterApp } from './containers';
import type { Configuration } from './models/configuration';

export const render = (rootEl: HTMLElement) => {
  const { config = '' } = rootEl.dataset;

  if (!config) {
    throw new Error('No config provided!');
  }

  const { globalApiUrl, tenant } = JSON.parse(config) as Configuration;
  const configuration: Configuration = {
    globalApiUrl: globalApiUrl ?? process.env.REACT_APP_API_URL,
    lang: document.documentElement.lang,
    tenant: tenant ?? process.env.REACT_APP_TENANT,
  };

  ReactDOM.render(<SupportCenterApp {...configuration} />, rootEl);
};
